export enum EmployeeParameters {
  None = 0,
  // eslint-disable-next-line no-bitwise
  Driver = 1 << 0
}

export const EmployeeParametersMapping: Record<EmployeeParameters, string> = {
  [EmployeeParameters.None]: 'None',
  [EmployeeParameters.Driver]: 'Driver'
};
